// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6b9985be","64":"3912cdb6","116":"2e148e98","472":"55a07a0d","626":"44dda877","786":"3c4c341c"}[chunkId] + ".chunk.js";
};